import axios from '@/plugins/axios';

export function registWxConfirmDwz(params) {
  return axios.post('/dwz/registWxConfirmDwz', params);
}

export function registDwz(params) {
  return axios.post('/dwz/registDwz', {
    operType: params.operType,
    storeKey: params.storeKey,
    timeOut: params.timeOut
  });
}

export function registWxDwz(params) {
  return axios.post('/dwz/registWxDwz', {
    operType: params.operType,
    storeKey: params.storeKey,
    timeOut: params.timeOut
  });
}
